export default "__VITE_ASSET__HnNstE99__"